import React, { useCallback } from 'react'
import AsyncSelect from 'react-select/async'
import TextField from '@material-ui/core/TextField'
import { makeStyles } from '@material-ui/core/styles'
import { useQuery } from '@apollo/react-hooks'
import _ from 'lodash'

import styles from './styles'
import { CompaniesQuery } from 'store'
import { TCompanySearchSelect } from 'models'

const useStyles = makeStyles(styles)

const inputComponent: (props: any) => JSX.Element = ({
	inputRef,
	...props
}) => <div ref={inputRef} {...props} style={{borderBottomColor: 'red'}}/>

const Control: (props: any) => JSX.Element = ({
	children,
	innerProps,
	innerRef,
	selectProps: { classes, TextFieldProps },
}) => (
	<TextField
		fullWidth
		variant="outlined"
		InputProps={{
			inputComponent,
			inputProps: {
				className: classes.input,
				ref: innerRef,
				children,
				...innerProps,
			},
			classes:{
				root: classes.outlinedSearchInput,
				notchedOutline: classes.notchedOutline
			}
		}}
		{...TextFieldProps}
	/>
)

const components = {
	Control,
}

const CompanySearchSelect: React.FunctionComponent<TCompanySearchSelect> = ({
	filterByCompany,
}) => {
	const classes = useStyles()
	// const [inputValue, setInputValue] = useState('')

	const handleChange = useCallback(
		(value: any) => {
			filterByCompany && filterByCompany(value)
		},
		[filterByCompany],
	)

	const { refetch: refetchCompanies } = useQuery(CompaniesQuery, {
		skip: true,
	})

	const debouncedFetchCompanies = useCallback(
		_.debounce((searchTerm: any, callback: any) => {
			refetchCompanies({
				data: {
					name: searchTerm,
				},
			})
				.then((result: any) => {
					if (result) {
						return callback(
							result.data.companies.map((item: any) => {
								let tempItem = {
									value: '',
									label: '',
								}
								tempItem.value = item.id
								tempItem.label = item.name
								return tempItem
							}),
						)
					} else {
						return callback([])
					}
				})
				.catch((error: any) => callback(error, null))
		}, 500),
		[],
	)

	const getCompaniesOptions = useCallback(
		(input: any, callback: any) => {
			if (!input) {
				return Promise.resolve({ options: [] })
			}
			debouncedFetchCompanies(input, callback)
		},
		[debouncedFetchCompanies],
	)

	return (
		<div>
			<AsyncSelect
				// cacheOptions
				loadOptions={getCompaniesOptions}
				defalutOptions
				onChange={handleChange}
				placeholder={'Company'}
				classes={classes}
				components={components}
				isClearable={true}
				backspaceRemovesValue={true}
			/>
		</div>
	)
}

export default CompanySearchSelect
